import { useMemo } from "react";
import dayjs from "dayjs";

export function useChannelGridCompare({
  rawVideo,
  selectedDate,
  fourthDate, // ✅ yeni
  startTime,
  endTime,
  ttvRawVideo, // optional: reference TTV channel's per-minute data, same shape as rawVideo
}) {
  return useMemo(() => {
    if (!rawVideo || !selectedDate) return [];

    const toMinute = (t) => {
      const [h, m] = t.split(":").map(Number);
      return h * 60 + m;
    };

    const startMinute = toMinute(startTime);
    const endMinute = toMinute(endTime);
    if (endMinute < startMinute) return [];

    // HH:mm labels
    const labels = [];
    for (let i = startMinute; i <= endMinute; i++) {
      const hh = String(Math.floor(i / 60)).padStart(2, "0");
      const mm = String(i % 60).padStart(2, "0");
      labels.push(`${hh}:${mm}`);
    }

    const base = dayjs(selectedDate, "YYYY-MM-DD");

    const days = [
      { name: "CURRENT", day: base },
      { name: "YESTERDAY", day: base.subtract(1, "day") },
      { name: "LAST WEEK", day: base.subtract(7, "day") },
    ];

    // ✅ fourth line ekle (varsa)
    if (fourthDate) {
      const fourth = dayjs(fourthDate, "YYYY-MM-DD");

      // aynı gün seçilirse duplicate engelle
      const isDuplicate = days.some(d => d.day.isSame(fourth, "day"));

      if (!isDuplicate) {
        days.push({
          name: "FOURTH LINE",
          day: fourth,
        });
      }
    }

    const buildValues = (source, key) => {
      const arr = Array.isArray(source[key]) ? source[key] : [];
      return arr
        .slice(startMinute, endMinute + 1)
        .map((v) => Math.round((Number(v) || 0) / 2));
    };

    const lines = days.map(({ name, day }) => {
      const key = day.format("DD-MM-YYYY");
      const values = buildValues(rawVideo, key);

      return {
        name,
        data: values.map((v, i) => ({
          x: labels[i],
          active: v,
        })),
      };
    });

    if (ttvRawVideo) {
      const key = base.format("DD-MM-YYYY");
      const values = buildValues(ttvRawVideo, key);

      lines.push({
        name: "TMTV",
        data: values.map((v, i) => ({
          x: labels[i],
          active: v,
        })),
      });
    }

    return lines;
  }, [rawVideo, selectedDate, fourthDate, startTime, endTime, ttvRawVideo]);
}